import React,{useEffect} from "react";
import './App.css';
import Home from "./Components/Home/Home";
import Navbar from "./Components/Header/Navbar";
import Project from "./Components/Projects/Project";
import Contact from "./Components/Contact/Contact";
import Certificates from "./Components/Certificates/Certificates";
import Footer from "./Components/Footer/footer"
import About from "./Components/About/About";
import Aos from "aos";
import Experience from "./Components/Experience/Experience";

import "aos/dist/aos.css";
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {

  useEffect(()=>{
      Aos.init({
        duration:2000,
       
      })
  },[])

  return (
   <div className="co">
     <div className="backcol">
      <Navbar />
      <Home />
      </div>
      <About />
      <Experience />
     <Project />
     <Certificates />   
     <Contact />
     <Footer />  
   </div>
  );
}

export default App;
